const initialState = {
	activeTab: "grid"
};

const activeTabReducer = (state = initialState, action) => {
	if (action.type === "activeTab") {
		return { ...state, activeTab: action.value };
	}
	return state;
};

export default activeTabReducer;
